//http://kml4earth.appspot.com/icons.html#mapfiles
const MAP_ICONS = {
    CLIENT: {
        url: 'https://maps.google.com/mapfiles/kml/paddle/grn-blank.png',
        // size: {width: 46, height: 56, f: 'px', b: 'px'},
        scaledSize: { width: 53, height: 43, f: 'px', b: 'px'},
        labelOrigin: {x: 26, y: 15}
    },
    EMPLOYEE: {
        url: 'http://maps.google.com/mapfiles/kml/paddle/blu-blank.png',
        // size: {width: 46, height: 56, f: 'px', b: 'px'},
        scaledSize: { width: 53, height: 43, f: 'px', b: 'px'},
        labelOrigin: {x: 26, y: 15}
    },
    SELECTED: {
        url: 'http://maps.google.com/mapfiles/kml/paddle/ylw-blank.png',
        // size: {width: 46, height: 56, f: 'px', b: 'px'},
        scaledSize: { width: 53, height: 43, f: 'px', b: 'px'},
        labelOrigin: {x: 26, y: 15}
    },
};

export {
    MAP_ICONS,
}